export default __webpack_public_path__ + "197d7edbaf017d8935d89b00cd51beec.jpg";